import { Box, Button, Checkbox, CircularProgress, Fab, IconButton, Menu, MenuItem, Paper, Radio, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { font } from "../../styles/font";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useErrorHandler from "../../api/errorHandler/useErrorHandler";
import { useApplicationContext } from "../../context/ApplicationContext";
import { CHART_COLORS, CHART_OPTIONS, Dashboard_Entity, Entity } from "../../constant/ApplicationVariables";
import { Add, ArrowBackOutlined, CheckOutlined, DescriptionOutlined, FolderOutlined, KeyboardArrowDown, KeyboardArrowRight, MoreHorizOutlined, MoreVert, MoreVertOutlined, SaveOutlined } from "@mui/icons-material";
import DashboardCard from "./DashboardCard";
import { forwardRef } from "react";
import { TableVirtuoso } from "react-virtuoso";
import { ValueComponent } from "../common/previewTemplate/CustomTextFormatting";
import { LightTooltip } from "../styled/CustomComponent";
import { amber, blue, brown, cyan, deepOrange, deepPurple, green, grey, indigo, lightBlue, lightGreen, lime, orange, pink, purple, red, teal, yellow } from "@mui/material/colors";
import { Bar } from "react-chartjs-2";
import { FaBoxTissue } from "react-icons/fa";
import { DatePicker, DesktopDatePicker } from "@mui/x-date-pickers";
import AutoSizer from "react-virtualized-auto-sizer";
import { Tree } from "react-arborist";
import ProjectOverView from "./project/Project_OverView";
import ProjectDashboardContainer from "./project";
import CalenderRangeButton from "../common/CalenderRangeButton";
import dayjs from "dayjs";
import RequirementToTestingDashboardContainer from "./requirementToTesting";

export default function DashboardContainerComponent() {
    const {
        isGridViewEnabled, setIsGridViewEnabled,
        handleSnackbar,
        isActiveProjectContainerLoading, setIsActiveProjectContainerLoading,
        activeProject,
        activeDashboard,
        setActiveDashboard
    } = useApplicationContext();
    const theme = useTheme();
    const errorHandler = useErrorHandler();
    const pathName = useLocation().pathname;


    const [isLoading, setIsLoading] = useState(false);
    const [dashboardType, setDashboardType] = useState("public");


    const handleComponent = () => {
        switch (activeDashboard?.value) {
            case Dashboard_Entity.project.value: return <ProjectDashboardContainer />;
            case Dashboard_Entity.userStory.value: return <RequirementToTestingDashboardContainer />;
            case Dashboard_Entity.useCase.value: return <RequirementToTestingDashboardContainer />;
            case Dashboard_Entity.testCase.value: return <RequirementToTestingDashboardContainer />;
            case Dashboard_Entity.teams.value: return "teams";
            case Dashboard_Entity.cost.value: return "cost";
            case Dashboard_Entity.userPersona.value: return "UserPersona";
            case Dashboard_Entity.qualityAssurance.value: return "QualityAssurance";
            case Dashboard_Entity.planning.value: return "Planning";
            case Dashboard_Entity.execution.value: return "Execution";
            case Dashboard_Entity.risks.value: return "Risks";
            case Dashboard_Entity.issues.value: return "Issues";
            case Dashboard_Entity.dependencies.value: return "Dependencies";
            default: return <ProjectDashboardContainer />
        }
    }



    return (
        <Box className="flex flex-col gap-4 w-full h-full overflow-hidden   " >

            {/* main container */}
            <Box className={`flex relative w-full  h-full overflow-hidden `} >
                {
                    (isLoading || isActiveProjectContainerLoading) && (
                        <Box className={`grow flex flex-col gap-2 items-center justify-center absolute left-0 right-0 top-0 bottom-0 `}>
                            <CircularProgress />
                            <Typography fontSize={font.size.fs_5}>Loading...</Typography>
                        </Box>
                    )
                }



                {/* main container */}
                <Box className="flex-1 flex flex-col gap-4 overflow-hidden">

                    {/* private/public , date filter */}
                    {false && <Box className="w-full h-fit flex items-center justify-between gap-4 ">
                        {activeDashboard?.value === Dashboard_Entity.project.value && (
                            <Tabs
                                value={dashboardType}
                                className="border-b"
                                onChange={(event, newValue) => {
                                    setDashboardType(newValue);
                                }}
                            >
                                <Tab label="Public" value={"public"} />
                                <Tab label="Private" value={"private"} />
                            </Tabs>
                        )}


                        <Box className="flex items-center gap-2 w-72 ml-auto">

                            <DesktopDatePicker
                                label="Start Date"
                                onChange={(newValue) => {
                                    // handle start date change
                                }}
                                renderInput={(params) => <TextField {...params} />}
                            />
                            <Typography>-</Typography>
                            <DesktopDatePicker
                                label="End Date"
                                onChange={(newValue) => {
                                    // handle end date change
                                }}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </Box>

                    </Box>}

                    {/* main container */}
                    <Box className="flex-1 flex gap-4 overflow-hidden">
                        {handleComponent()}
                    </Box>
                </Box>


            </Box>
        </Box>
    )
}


function DashboardCard2() {
    const theme = useTheme();


    return (
        <Box className=" flex flex-col justify-between px-4 py-4 w-full h-full" bgcolor={theme.palette.background.default}>
            <Box className="flex items-center justify-between">
                <Typography fontSize={font.size.fs_4} color={"textSecondary"}>Revenue</Typography>
                <IconButton>
                    <MoreHorizOutlined />
                </IconButton>
                {/* <Radio size="small" /> */}
            </Box>

            <Box className="flex items-center justify-between">
                <Typography fontSize={font.size.fs_2} fontWeight={"bold"} color={"textSecondary"}>$2000</Typography>

            </Box>
        </Box>
    )
}

function ProjectDashboardContainer2() {
    const theme = useTheme();
    const errorHandler = useErrorHandler();
    const pathName = useLocation().pathname;


    class ProjectDashboard_Tabs {
        static overview = "Overview";
        static scrum = "Daily Scrum";
        static tasks = "Tasks";
        static kanban = "Kanban";
        static sprint = "Sprint";
        static tracebility = "Tracebility";
        static counters = "Counters";
        static csat = "CSAT";
        static defect = "Defect";
    }


    const [dashboardType, setDashboardType] = useState("public");
    const [dataList, setDataList] = useState([
        {
            title: "User Story",
            type: "counter",
            isSelectable: false,
            data: "2597"
        },
        {
            title: "Use Case",
            type: "counter",
            isSelectable: false,
            data: "7464"
        },
        {
            title: "Test Case",
            type: "counter",
            isSelectable: false,
            data: "8765"
        },

    ]);

    const [dataListOther, setDataListOther] = useState([

        {
            title: "Priority",
            type: "doughnut",
            isSelectable: true,
            data: {
                labels: ['HIGH', 'MEDIUM', 'LOW',],
                datasets: [
                    {
                        // label: '# of Votes',
                        label: '',
                        data: [32, 40, 28],
                        backgroundColor: [
                            'rgba(255, 99, 132, 0.2)',
                            'rgba(54, 162, 235, 0.2)',
                            'rgba(255, 206, 86, 0.2)',
                            'rgba(75, 192, 192, 0.2)',
                            'rgba(153, 102, 255, 0.2)',
                            'rgba(255, 159, 64, 0.2)',
                        ],
                        borderColor: [
                            'rgba(255, 99, 132, 1)',
                            'rgba(54, 162, 235, 1)',
                            'rgba(255, 206, 86, 1)',
                            'rgba(75, 192, 192, 1)',
                            'rgba(153, 102, 255, 1)',
                            'rgba(255, 159, 64, 1)',
                        ],
                        borderWidth: 1,
                    },
                ],
            }
        }
    ]);





    const [activeProjectDashboard, setActiveProjectDashboard] = useState(ProjectDashboard_Tabs.overview);
    const [tabsList, setTabsList] = useState([
        ProjectDashboard_Tabs.overview,
        ProjectDashboard_Tabs.scrum,
        ProjectDashboard_Tabs.tasks,
        ProjectDashboard_Tabs.kanban,
        ProjectDashboard_Tabs.sprint,
        ProjectDashboard_Tabs.tracebility,
        ProjectDashboard_Tabs.counters,
        ProjectDashboard_Tabs.csat,
        ProjectDashboard_Tabs.defect
    ]);

    const handleChangeProjectDashboard = (event, newValue) => {
        setActiveProjectDashboard(newValue);
    }


    const handleComponent = (value) => {
        switch (value) {
            case ProjectDashboard_Tabs.overview: return <ProjectOverView />;
            default: return <>Coming Soon</>
        }
    }

    return (
        <Box className="flex-1 flex flex-col gap-4 overflow-hidden">

            {/* header tabs  */}
            <Box className="flex items-center justify-center gap-4 min-h-fit max-h-fit overflow-hidden">
                <Tabs
                    // centered
                    variant="scrollable"
                    scrollButtons={false}
                    selectionFollowsFocus
                    textColor="secondary"
                    indicatorColor="secondary"

                    value={activeProjectDashboard}
                    onChange={handleChangeProjectDashboard}
                >
                    {tabsList?.map((label, index) => (
                        <Tab key={index} value={label} label={label} />
                    ))}
                </Tabs>
            </Box>

            {/* main container */}
            <Box className="grow flex flex-col overflow-y-auto">
                {handleComponent(activeProjectDashboard)}
            </Box>
        </Box>

    )

    return (
        <Box className="flex-1 flex flex-wrap gap-4 overflow-y-auto">

            <Box className="w-full h-fit flex items-center justify-between gap-4 ">

                <Tabs
                    value={dashboardType}
                    className="border-b"
                    onChange={(event, newValue) => {
                        setDashboardType(newValue);
                    }}
                >
                    <Tab label="Public" value={"public"} />
                    <Tab label="Private" value={"private"} />
                </Tabs>



                <Box className="flex items-center gap-2 w-72 ml-auto">

                    <DesktopDatePicker
                        label="Start Date"
                        onChange={(newValue) => {
                            // handle start date change
                        }}
                        renderInput={(params) => <TextField {...params} />}
                    />
                    <Typography>-</Typography>
                    <DesktopDatePicker
                        label="End Date"
                        onChange={(newValue) => {
                            // handle end date change
                        }}
                        renderInput={(params) => <TextField {...params} />}
                    />
                </Box>

            </Box>

            {/* project card */}
            <Box className="w-full h-fit flex  flex-wrap gap-4 pl-0  py-0 ">
                {
                    dataList?.map((item, index) => {
                        return (
                            <Box
                                key={index}
                                className={` overflow-hidden rounded-lg border hover:shadow-2xl  backdrop-blur-md transition-all ease-in-out duration-300 

                                     `}
                                bgcolor={theme.palette.card.main}
                                // onClick={() => handleOpenProject(project)}
                                sx={{ border: `1px solid transparent`, "&:hover": { border: `1px solid ${theme.palette.primary.main}` } }}
                            >
                                <DashboardCard
                                    item={item}
                                    isSelectable={item.isSelectable}
                                // handleClick={() => handleOpenUserStory(item)}
                                // handleChangeCheckbox={handleChangeCheckbox}
                                // handleOpenLinkTag={handleOpenLinkTag}
                                />

                            </Box>
                        )
                    })
                }
            </Box>

            {/* other card */}
            <Box className="w-full h-fit flex  flex-wrap gap-4 pl-0  py-0 ">
                {
                    dataListOther?.map((item, index) => {
                        return (
                            <Box
                                key={index}
                                className={` overflow-hidden rounded-lg border hover:shadow-2xl  backdrop-blur-md transition-all ease-in-out duration-300 

                                     `}
                                bgcolor={theme.palette.card.main}
                                // onClick={() => handleOpenProject(project)}
                                sx={{ border: `1px solid transparent`, "&:hover": { border: `1px solid ${theme.palette.primary.main}` } }}
                            >
                                <DashboardCard
                                    item={item}
                                    isSelectable={item.isSelectable}
                                // handleClick={() => handleOpenUserStory(item)}
                                // handleChangeCheckbox={handleChangeCheckbox}
                                // handleOpenLinkTag={handleOpenLinkTag}
                                />

                            </Box>
                        )
                    })
                }
            </Box>
        </Box>
    )
}

function RequirementToTestingContainer2() {
    const { activeDashboard, setActiveDashboard } = useApplicationContext();
    const theme = useTheme();
    const errorHandler = useErrorHandler();
    const pathName = useLocation().pathname;

    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.up("sm") && theme.breakpoints.down("md"));
    const isLaptop = useMediaQuery(theme.breakpoints.up("md") && theme.breakpoints.down("lg"));
    const isDesktop = useMediaQuery(theme.breakpoints.up("lg") && theme.breakpoints.down("xl"));
    const isLargeDisplay = useMediaQuery(theme.breakpoints.up("xl"));

    const [openCreateGraphDialog, setOpenCreateGraphDialog] = useState(false);

    const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);

    const [activeProperty, setActiveProperty] = useState({
        label: "All",
        value: ""
    });
    const [currentGraphData, setCurrentGraphData] = useState(null);
    const [searchText, setSearchText] = useState("");

    const [selectedDate, setSelectedDate] = useState({
        startDate: dayjs(),
        endDate: dayjs()
    });



    // left list of properties
    let propertiesList = [
        {
            label: "Overview",
            value: ""
        },
        {
            label: "Priority",
            value: "Priority"
        },
        {
            label: "State",
            value: "State"
        },
        {
            label: "Type",
            value: "Type"
        },
        {
            label: "MOSCOW",
            value: "MOSCOW"
        },
        {
            label: "Confidentiality",
            value: "Confidentiality"
        },
        {
            label: "Owner",
            value: "Owner"
        },
        {
            label: "Business Value",
            value: "Business Value"
        },
        {
            label: "User Value",
            value: "User Value"
        },
        {
            label: "Assigned",
            value: "Assigned"
        },
        {
            label: "Planned Value",
            value: "Planned Value"
        },
        {
            label: "Actual Value",
            value: "Actual Value"
        },
        {
            label: "Linked Usecase",
            value: "Linked Usecase"
        },
        {
            label: "Linked TestCase",
            value: "Linked TestCase"
        },
        {
            label: "Attachements",
            value: "Attachements"
        },
        {
            label: "Acceptance Criteria",
            value: "Acceptance Criteria"
        },
        {
            label: "Dependencies",
            value: "Dependencies"
        },
        {
            label: "Comments",
            value: "Comments"
        },
        {
            label: "Business Unit",
            value: "Business Unit"
        },
        {
            label: "Vendor",
            value: "Vendor"
        },
        {
            label: "External Party",
            value: "External Party"
        }
    ];

    // card 
    // const [dataList, setOverviewList] = useState([
    //     {
    //         title: activeProperty,
    //         type: "doughnut",
    //         data: {
    //             labels: ['HIGH', 'MEDIUM', 'LOW'],
    //             datasets: [
    //                 {
    //                     // label: '# of Votes',
    //                     label: '',
    //                     data: [32, 40, 28],
    //                     backgroundColor: [
    //                         'rgba(255, 99, 132, 0.2)',
    //                         'rgba(54, 162, 235, 0.2)',
    //                         'rgba(255, 206, 86, 0.2)',
    //                         'rgba(75, 192, 192, 0.2)',
    //                         'rgba(153, 102, 255, 0.2)',
    //                         'rgba(255, 159, 64, 0.2)',
    //                     ],
    //                     borderColor: [
    //                         'rgba(255, 99, 132, 1)',
    //                         'rgba(54, 162, 235, 1)',
    //                         'rgba(255, 206, 86, 1)',
    //                         'rgba(75, 192, 192, 1)',
    //                         'rgba(153, 102, 255, 1)',
    //                         'rgba(255, 159, 64, 1)',
    //                     ],
    //                     borderWidth: 1,
    //                 },
    //             ],
    //         }
    //     }
    // ]);

    const [overviewList, setOverviewList] = useState([
        {
            title: "User Story",
            type: "counter",
            isSelectable: false,
            data: "2597"
        },
        {
            title: "Priority",
            type: "doughnut",
            isSelectable: true,
            data: {
                labels: ['HIGH', 'MEDIUM', 'LOW',],
                datasets: [
                    {
                        // label: '# of Votes',
                        label: '',
                        data: [32, 40, 28],
                        backgroundColor: [
                            'rgba(255, 99, 132, 0.2)',
                            'rgba(54, 162, 235, 0.2)',
                            'rgba(255, 206, 86, 0.2)',
                            'rgba(75, 192, 192, 0.2)',
                            'rgba(153, 102, 255, 0.2)',
                            'rgba(255, 159, 64, 0.2)',
                        ],
                        borderColor: [
                            'rgba(255, 99, 132, 1)',
                            'rgba(54, 162, 235, 1)',
                            'rgba(255, 206, 86, 1)',
                            'rgba(75, 192, 192, 1)',
                            'rgba(153, 102, 255, 1)',
                            'rgba(255, 159, 64, 1)',
                        ],
                        borderWidth: 1,
                    },
                ],
            }
        }
    ]);


    // table, graph data - priority
    const list2 = [
        {
            name: "Folder1",
            value: 110,
            properties: [
                {
                    name: "HIGH",
                    value: 40
                },
                {
                    name: "MEDIUM",
                    value: 30
                },
                {
                    name: "LOW",
                    value: 60
                },
            ]

        },
        {
            name: "Folder2",
            value: 110,
            properties: [
                {
                    name: "HIGH",
                    value: 20
                },
                {
                    name: "MEDIUM",
                    value: 30
                },
                {
                    name: "LOW",
                    value: 60
                }
            ]
        },
        {
            name: "Folder3",
            value: 110,
            properties: [
                {
                    name: "HIGH",
                    value: 20
                },
                {
                    name: "MEDIUM",
                    value: 30
                },
                {
                    name: "LOW",
                    value: 60
                }
            ]
        },
        {
            name: "Folder4",
            value: 110,
            properties: [
                {
                    name: "HIGH",
                    value: 20
                },
                {
                    name: "MEDIUM",
                    value: 30
                },
                {
                    name: "LOW",
                    value: 60
                }
            ]
        },
        {
            name: "Folder5",
            value: 110,
            properties: [
                {
                    name: "HIGH",
                    value: 20
                },
                {
                    name: "MEDIUM",
                    value: 30
                },
                {
                    name: "LOW",
                    value: 60
                }
            ]
        }
    ]

    // table, graph data - state
    const list = [
        {
            name: "Folder1",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]

        },
        {
            name: "Folder2",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        },
        {
            name: "Folder3",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        },
        {
            name: "Folder4",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        },
        {
            name: "Folder5",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        }
    ];

    const graphList = [
        { title: "All Folder", list: list },
        { title: "5folders", list: list },
        { title: "3folders", list: list },
        { title: "2folders", list: list },
        { title: "7folders", list: list }
    ];




















    let priorityStateList = [
        {
            title: "Title of data",
            type: "doughnut",
            data: {
                labels: ["Folder1", "Folder2", "Folder3", "Folder4", "Folder5"],
                datasets: [
                    {
                        label: 'HIGH',
                        data: [12, 19, 45, 5, 89],
                    },
                    {
                        label: 'MEDIUM',
                        data: [56, 74, 54, 46, 6],
                    },
                    {
                        label: 'LOW',
                        data: [56, 45, 5, 66, 6],
                    },
                ],
                colorsList: ["#7d7d8d", "#3f5gd1", "#ff9800", "#4caf50", "#2196f3"]
            },
            tableList: [
                {
                    name: "Folder1",
                    value: 110,
                    properties: [
                        {
                            name: "DRAFT",
                            value: 40
                        },
                        {
                            name: "APPROVED",
                            value: 30
                        },
                        {
                            name: "UNDER DEVELOPMENT",
                            value: 60
                        },
                        {
                            name: "COMPLETED",
                            value: 60
                        },
                        {
                            name: "CLOSED",
                            value: 50
                        },
                    ]

                },
                {
                    name: "Folder2",
                    value: 110,
                    properties: [
                        {
                            name: "DRAFT",
                            value: 40
                        },
                        {
                            name: "APPROVED",
                            value: 30
                        },
                        {
                            name: "UNDER DEVELOPMENT",
                            value: 60
                        },
                        {
                            name: "COMPLETED",
                            value: 60
                        },
                        {
                            name: "CLOSED",
                            value: 50
                        },
                    ]
                },
                {
                    name: "Folder3",
                    value: 110,
                    properties: [
                        {
                            name: "DRAFT",
                            value: 40
                        },
                        {
                            name: "APPROVED",
                            value: 30
                        },
                        {
                            name: "UNDER DEVELOPMENT",
                            value: 60
                        },
                        {
                            name: "COMPLETED",
                            value: 60
                        },
                        {
                            name: "CLOSED",
                            value: 50
                        },
                    ]
                },
                {
                    name: "Folder4",
                    value: 110,
                    properties: [
                        {
                            name: "DRAFT",
                            value: 40
                        },
                        {
                            name: "APPROVED",
                            value: 30
                        },
                        {
                            name: "UNDER DEVELOPMENT",
                            value: 60
                        },
                        {
                            name: "COMPLETED",
                            value: 60
                        },
                        {
                            name: "CLOSED",
                            value: 50
                        },
                    ]
                },
                {
                    name: "Folder5",
                    value: 110,
                    properties: [
                        {
                            name: "DRAFT",
                            value: 40
                        },
                        {
                            name: "APPROVED",
                            value: 30
                        },
                        {
                            name: "UNDER DEVELOPMENT",
                            value: 60
                        },
                        {
                            name: "COMPLETED",
                            value: 60
                        },
                        {
                            name: "CLOSED",
                            value: 50
                        },
                    ]
                }
            ]
        },
        {
            title: "Title of data2",
            type: "doughnut",
            data: {
                labels: ["Folder1", "Folder2", "Folder3", "Folder4", "Folder5"],
                datasets: [
                    {
                        label: 'HIGH',
                        data: [17, 20, 41, 7, 93],
                    },
                    {
                        label: 'MEDIUM',
                        data: [51, 64, 44, 36, 16],
                    },
                    {
                        label: 'LOW',
                        data: [51, 35, 7, 76, 16],
                    },
                ],
                colorsList: ["#7d7d8d", "#3f5gd1", "#ff9800", "#4caf50", "#2196f3"]
            },
            tableList: [
                {
                    name: "Folder1",
                    value: 110,
                    properties: [
                        {
                            name: "DRAFT",
                            value: 40
                        },
                        {
                            name: "APPROVED",
                            value: 30
                        },
                        {
                            name: "UNDER DEVELOPMENT",
                            value: 60
                        },
                        {
                            name: "COMPLETED",
                            value: 60
                        },
                        {
                            name: "CLOSED",
                            value: 50
                        },
                    ]

                },
                {
                    name: "Folder2",
                    value: 110,
                    properties: [
                        {
                            name: "DRAFT",
                            value: 40
                        },
                        {
                            name: "APPROVED",
                            value: 30
                        },
                        {
                            name: "UNDER DEVELOPMENT",
                            value: 60
                        },
                        {
                            name: "COMPLETED",
                            value: 60
                        },
                        {
                            name: "CLOSED",
                            value: 50
                        },
                    ]
                },
                {
                    name: "Folder3",
                    value: 110,
                    properties: [
                        {
                            name: "DRAFT",
                            value: 40
                        },
                        {
                            name: "APPROVED",
                            value: 30
                        },
                        {
                            name: "UNDER DEVELOPMENT",
                            value: 60
                        },
                        {
                            name: "COMPLETED",
                            value: 60
                        },
                        {
                            name: "CLOSED",
                            value: 50
                        },
                    ]
                },
                {
                    name: "Folder4",
                    value: 110,
                    properties: [
                        {
                            name: "DRAFT",
                            value: 40
                        },
                        {
                            name: "APPROVED",
                            value: 30
                        },
                        {
                            name: "UNDER DEVELOPMENT",
                            value: 60
                        },
                        {
                            name: "COMPLETED",
                            value: 60
                        },
                        {
                            name: "CLOSED",
                            value: 50
                        },
                    ]
                },
                {
                    name: "Folder5",
                    value: 110,
                    properties: [
                        {
                            name: "DRAFT",
                            value: 40
                        },
                        {
                            name: "APPROVED",
                            value: 30
                        },
                        {
                            name: "UNDER DEVELOPMENT",
                            value: 60
                        },
                        {
                            name: "COMPLETED",
                            value: 60
                        },
                        {
                            name: "CLOSED",
                            value: 50
                        },
                    ]
                }
            ]
        },


    ];



    let overviewlistDummy = [
        {
            title: "User Story",
            type: "counter",
            data: 7454,

        },
        {
            title: "Priority",
            type: "doughnut",
            data: {
                labels: ["HIGH", "MEDIUM", "LOW",],
                datasets: [
                    {
                        label: '',
                        data: [12, 19, 45,]
                    },

                ],
                colorsList: ["#7d7d8d", "#3f5gd1", "#ff9800",]
            },

        },
        {
            title: "State",
            type: "doughnut",
            data: {
                labels: ['DRAFT', 'INPROGRESS', 'APPROVED', "COMPLETED", "CLOSED"],
                datasets: [
                    {
                        label: '',
                        data: [32, 40, 28, 30, 50],
                    },
                ],
                colorsList: ["#7d7d8d", "#3f5gd1", "#ff9800", "#4caf50", "#2196f3"]
            },

        },
        {
            title: "Type",
            type: "doughnut",
            data: {
                labels: ['PROCESS', 'FUNCTIONAL', 'NON-FUNCTIONAL',],
                datasets: [
                    {
                        label: '',
                        data: [32, 40, 28],
                    },
                ],
                colorsList: ["#7d7d8d", "#3f5gd1", "#ff9800",]
            },

        },


    ];










    const list5 = [
        {
            name: "Folder1",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]

        },
        {
            name: "Folder2",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        },
        {
            name: "Folder3",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        },
        {
            name: "Folder4",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        },
        {
            name: "Folder5",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        }
    ];


    const handleOpenGraphPreview = (item) => {
        setCurrentGraphData(item);
    }

    const handleCloseGraphPreview = () => {
        setCurrentGraphData(null);
    }

    const handleOpenCreateGraph = () => {
        setOpenCreateGraphDialog(true)
    }

    const handleCloseCreateGraph = () => {
        setOpenCreateGraphDialog(false)
    }


    const handleToggleMoreMenu = (event) => {
        if (moreMenuAnchorEl) {
            setMoreMenuAnchorEl(null);
        } else {
            setMoreMenuAnchorEl(event.currentTarget);
        }
    }

    let DATASETS = {
        // label: '# of Votes',
        label: '',
        data: [],
        backgroundColor: CHART_COLORS?.map(color => color[400]),
        borderColor: CHART_COLORS?.map(color => color[700]),
        borderWidth: 1,
    }

    function transformData(labelList, datasetList, colorList) {
        const labels = labelList?.map(item => item);
        const datasets = datasetList?.map((dataSet, index) => ({
            label: dataSet?.label,
            data: dataSet?.data,
            backgroundColor: colorList ? colorList[index] : CHART_COLORS[index][400],
            borderColor: colorList ? colorList[index] : CHART_COLORS[index][700],
            borderWidth: 1,
        }));

        return { labels, datasets };
    }

    let overViewDummyDataList = [
        {
            title: "Title of data",
            type: "charttype",
            data: {
                labels: ["label1", "label1", "label2", "label3", "label4"],
                datasets: [
                    {
                        label: '# of Votes',
                        data: [12, 19, 3, 5, 6],
                    },
                    {
                        label: '$ of Votes',
                        data: [56, 74, 5, 5, 6],
                    },
                ],
                colorsList: ["#7d7d8d", "#3f5gd1", "#ff9800", "#4caf50", "#2196f3"]
            }
        }
    ];

    console.log(transformData(overViewDummyDataList[0]?.data.labels, overViewDummyDataList[0]?.data.datasets, overViewDummyDataList[0]?.data?.colorsList), "overViewDummyData");



    // set the data list
    useEffect(() => {
        setOverviewList([
            {
                title: "User Story",
                type: "counter",
                data: "2597"
            },
            {
                // title: "activeProperty",
                title: "Priority",
                type: "doughnut",
                data: {
                    labels: ['HIGH', 'MEDIUM', 'LOW',],
                    datasets: [
                        {
                            ...DATASETS,
                            data: [32, 40, 28],
                        },
                    ],
                }
            },
            {
                title: "State",
                type: "doughnut",
                data: {
                    labels: ['DRAFT', 'INPROGRESS', 'APPROVED', "COMPLETED", "CLOSED"],
                    datasets: [
                        {
                            ...DATASETS,
                            data: [32, 40, 28, 30, 50],
                        },
                    ],
                }
            },
            {
                title: "Type",
                type: "doughnut",
                data: {
                    labels: ['PROCESS', 'FUNCTIONAL', 'NON-FUNCTIONAL',],
                    datasets: [
                        {
                            ...DATASETS,
                            data: [32, 40, 28],
                        },
                    ],
                }
            },
            {
                title: "MOSCOW",
                type: "doughnut",
                data: {
                    labels: ["MUST HAVE", "SHOULD HAVE", "COULD HAVE", "WONT HAVE"],
                    datasets: [
                        {
                            ...DATASETS,
                            data: [32, 40, 28, 30],

                        },
                    ],
                }
            },
            {
                title: "Confidentiality",
                type: "doughnut",
                data: {
                    labels: ['CONFIDENTIAL', 'SENSITIVE', 'UNCLASSIFIED',],
                    datasets: [
                        {
                            ...DATASETS,
                            data: [32, 40, 28],
                        },
                    ],
                }
            },
            {
                title: "Business Value",
                type: "doughnut",
                data: {
                    labels: ['Business Value',],
                    datasets: [
                        {
                            ...DATASETS,
                            data: [32,],
                        },
                    ],
                }
            },
            {
                title: "User Value",
                type: "doughnut",
                data: {
                    labels: ["User Value",],
                    datasets: [
                        {
                            ...DATASETS,
                            data: [46,],
                        },
                    ],
                }
            }
        ])
    }, [activeProperty]);

    console.log(overviewList, "overviewList", activeProperty);
    console.log(currentGraphData, "currentGraphData");

    console.log([...overviewList?.filter((item) => item?.type === "counter"), ...overviewList?.filter((item) => item?.type !== "counter")?.map((item) => ({ ...item, data: transformData(item?.data.labels, item?.data.datasets) }))], "overviewList2")

    return (
        <Box className="flex-1 flex gap-4 overflow-hidden box-border">



            {/* left list of properties */}
            {(activeDashboard?.value === Entity.userStory || activeDashboard?.value === Entity.useCase || activeDashboard?.value === Entity.testCase) && (
                <Box className="flex flex-col gap-4 px-0 py-0 w-[18%] h-full">
                    <TextField placeholder="Search" />

                    <Box className="flex-1 flex flex-col gap-2 overflow-y-auto">
                        {
                            propertiesList?.map((item, index) => {
                                return (
                                    <Box className="flex items-center gap-2 px-2 py-1" sx={{ cursor: "pointer", background: activeProperty?.value === item?.value ? theme.palette.background.paper : "none", "&:hover": { background: theme.palette.background.paper } }} borderRadius={theme.shape.borderRadius} onClick={() => setActiveProperty(item)}>
                                        <Typography fontSize={font.size.fs_5} color="textSecondary">{item?.label}</Typography>
                                    </Box>
                                )
                            })
                        }
                    </Box>
                </Box>
            )}



            {/* dashboard main container */}
            <Box className="flex-1 flex flex-col gap-4 relative overflow-hidden">



                {activeProperty?.value && (
                    <Box className="absolute bottom-2 right-2 z-10">
                        <LightTooltip title={`Create Graph`}>
                            <Fab
                                color="secondary"
                                // disabled={openEditStoryDialog}
                                onClick={handleOpenCreateGraph}
                                sx={{ boxShadow: "none" }}>
                                <Add />
                            </Fab>
                        </LightTooltip>
                    </Box>
                )}

                {!activeProperty?.value && (
                    <Box className="absolute bottom-2 right-2 z-10">
                        <LightTooltip title={`Add `}>
                            <Fab
                                color="secondary"
                                // disabled={openEditStoryDialog}
                                // onClick={handleOpenCreateGraph}
                                sx={{ boxShadow: "none" }}>
                                <Add />
                            </Fab>
                        </LightTooltip>
                    </Box>)}

                {openCreateGraphDialog && (
                    <Box className={`absolute top-0 right-0 bottom-0 left-0  w-full h-full backdrop-blur-md bg-white z-50 flex items-center justify-center overflow-hidden`} borderRadius={theme.shape.borderRadius} >
                        <CreateGraphComponent onClose={handleCloseCreateGraph} />
                    </Box>
                )}




                {/* header */}
                <Box className=" w-full h-fit flex items-center justify-between gap-4 ">

                    <Box className="flex items-center gap-2 w-72 ">

                        {/* <DesktopDatePicker
                            label="Start Date"
                            onChange={(newValue) => {
                                // handle start date change
                            }}
                            renderInput={(params) => <TextField {...params} />}
                        />
                        <Typography>-</Typography>
                        <DesktopDatePicker
                            label="End Date"
                            onChange={(newValue) => {
                                // handle end date change
                            }}
                            renderInput={(params) => <TextField {...params} />}
                        /> */}


                        <CalenderRangeButton selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
                    </Box>

                    <TextField placeholder="Search" type="search" value={searchText} onChange={(e) => setSearchText(e.target.value)} />

                </Box>


                {/* other properites container */}
                {activeProperty?.value && (
                    <Box className="flex-1 flex flex-col gap-0 relative overflow-y-auto ">


                        {/* card list container */}
                        {!currentGraphData ? (
                            <Box
                                className="grid grid-cols-1  sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 w-full h-fit  "
                            //  className="flex items-center flex-wrap gap-4 w-full h-fit  "

                            >
                                {
                                    priorityStateList
                                        ?.length === 0 ? (
                                        <Box className="flex items-center  ">
                                            <Typography>No data</Typography>
                                        </Box>

                                    ) :
                                        priorityStateList
                                            ?.filter((item => item?.title?.toLowerCase()?.includes(searchText?.toLowerCase())))
                                            ?.length === 0 ? (
                                            <Box className="flex items-center ">
                                                <Typography>No data</Typography>
                                            </Box>

                                        ) :
                                            priorityStateList
                                                ?.filter((item => item?.title?.toLowerCase()?.includes(searchText?.toLowerCase())))
                                                ?.map((item, index) => {
                                                    return (
                                                        <Box className=" flex flex-col gap-0 px-0 py-0 overflow-auto  w-full max-w-[440px] h-72  " bgcolor={theme.palette.background.paper} borderRadius={theme.shape.borderRadius} >
                                                            <Box className="flex items-center justify-between gap-4 px-4 py-2 border-b">
                                                                <Typography fontSize={font.size.fs_5} color="textSecondary">{item?.title}</Typography>

                                                                <IconButton onClick={handleToggleMoreMenu}>
                                                                    <MoreHorizOutlined />
                                                                </IconButton>
                                                            </Box>

                                                            <Box className="flex-1 flex items-center  gap-4 px-0 py-0 cursor-pointer select-none  relative overflow-auto" onClick={() => handleOpenGraphPreview(item)}>
                                                                <Box className="flex absolute left-0 top-0 w-full h-full"></Box>
                                                                <GraphComponent title={item?.title} data={item?.data} style={{ width: "100%", height: "100%" }} />
                                                            </Box>
                                                        </Box>
                                                    )
                                                })
                                }
                            </Box>) : (
                            <Box className={`absolute top-0 right-0 bottom-0 left-0  w-full h-full backdrop-blur-md bg-white z-50 flex items-center justify-center overflow-hidden`} borderRadius={theme.shape.borderRadius} >
                                <GraphPreview data={currentGraphData} onClose={handleCloseGraphPreview} />
                            </Box>
                        )}

                    </Box>
                )}

                {/* overview container  */}
                {!activeProperty?.value && (
                    <Box className="flex-1 flex flex-col gap-0 overflow-y-auto">
                        <Box className={`grid grid-cols-1  sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 pl-0 py-0`}>
                            {
                                overviewlistDummy?.map((item, index) => {
                                    return (
                                        <Box
                                            key={index}
                                            className={` overflow-hidden rounded-lg border hover:shadow-2xl  backdrop-blur-md transition-all ease-in-out duration-300 
                                            h-[320px]
                                     `}
                                            bgcolor={theme.palette.card.main}
                                        // onClick={() => handleOpenProject(project)}
                                        // sx={{ border: `1px solid transparent`, "&:hover": { border: `1px solid ${theme.palette.primary.main}` } }}
                                        >
                                            <DashboardCard
                                                item={item}
                                            // handleClick={() => handleOpenUserStory(item)}
                                            // handleChangeCheckbox={handleChangeCheckbox}
                                            // handleOpenLinkTag={handleOpenLinkTag}
                                            />

                                        </Box>
                                    )
                                })
                            }
                        </Box>
                    </Box>
                )}

            </Box>


            {/* more menu */}
            <Menu
                anchorEl={moreMenuAnchorEl}
                open={Boolean(moreMenuAnchorEl)}
                onClose={handleToggleMoreMenu}
            >
                <MenuItem> Add to Project Dashboard</MenuItem>
                <MenuItem> Duplicate</MenuItem>
                <MenuItem>Edit</MenuItem>
                <MenuItem> Delete</MenuItem>
            </Menu>
        </Box>
    )
}


function CreateGraphComponent({ onClose }) {
    const theme = useTheme();
    const [selectedItemsList, setSelectedItemsList] = useState([]); // to make section of checkbox

    const list = [
        {
            name: "Folder1",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]

        },
        {
            name: "Folder2",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        },
        {
            name: "Folder3",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        },
        {
            name: "Folder4",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        },
        {
            name: "Folder5",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        }
    ];



    const folderList = [
        {
            "id": "4ff39588-cbc0-4f7a-92b9-0c3dd38e6ec4",
            "name": "Default",
            "description": null,
            "path": "default",
            "section": "UseCase",
            "type": "UseCase",
            "children": [
                {
                    "id": "09efa887-694f-4ecc-b980-d1e490e4c674",
                    "name": "l-d1",
                    "description": null,
                    "path": "default/l-d1",
                    "section": "UseCase",
                    "type": "UseCase",
                    "children": [],
                    "userStoryCount": 0,
                    "useCaseCount": 2,
                    "testCaseCount": 0,
                    "lastModifiedAt": "2025-02-08T08:31:58.071946Z"
                },
                {
                    "id": "b76d072c-5cfc-4871-be6a-9bfb14f83c0d",
                    "name": "folder2",
                    "description": null,
                    "path": "default/folder2",
                    "section": "UseCase",
                    "type": "UseCase",
                    "children": [],
                    "userStoryCount": 0,
                    "useCaseCount": 0,
                    "testCaseCount": 0,
                    "lastModifiedAt": "2025-02-08T08:31:58.071946Z"
                }
            ],
            "userStoryCount": 0,
            "useCaseCount": 11,
            "testCaseCount": 0,
            "lastModifiedAt": "2025-02-08T08:31:58.071946Z"
        },
        {
            "id": "162cdc40-6736-474a-bcb5-d6b1ed02ba52",
            "name": "folder2",
            "description": null,
            "path": "folder2",
            "section": "UseCase",
            "type": "UseCase",
            "children": [
                {
                    "id": "9bfe62b3-e50f-4341-96ba-f39d90f56346",
                    "name": "folder2_sub",
                    "description": null,
                    "path": "folder2/folder2_sub",
                    "section": "UseCase",
                    "type": "UseCase",
                    "children": [],
                    "userStoryCount": 0,
                    "useCaseCount": 0,
                    "testCaseCount": 0,
                    "lastModifiedAt": "2025-02-08T08:31:58.071946Z"
                },
                {
                    "id": "33919137-8cc8-445d-b63c-26d13b7861a3",
                    "name": "jksdfdsf",
                    "description": null,
                    "path": "folder2/jksdfdsf",
                    "section": "UseCase",
                    "type": "UseCase",
                    "children": [],
                    "userStoryCount": 0,
                    "useCaseCount": 0,
                    "testCaseCount": 0,
                    "lastModifiedAt": "2025-02-08T08:31:58.071946Z"
                }
            ],
            "userStoryCount": 0,
            "useCaseCount": 1,
            "testCaseCount": 0,
            "lastModifiedAt": "2025-02-08T08:31:58.071946Z"
        },
        {
            "id": "75e9e43e-7800-49fb-ae05-8a50a7a38360",
            "name": "folder3",
            "description": null,
            "path": "folder3",
            "section": "UseCase",
            "type": "UseCase",
            "children": [],
            "userStoryCount": 0,
            "useCaseCount": 0,
            "testCaseCount": 0,
            "lastModifiedAt": "2025-02-08T08:31:58.071946Z"
        },
        {
            "id": "0976d907-c42f-47e2-81d3-a066a285bc2b",
            "name": "folder4",
            "description": null,
            "path": "folder4",
            "section": "UseCase",
            "type": "UseCase",
            "children": [],
            "userStoryCount": 0,
            "useCaseCount": 0,
            "testCaseCount": 0,
            "lastModifiedAt": "2025-02-08T08:31:58.071946Z"
        },
        {
            "id": "61f248af-b421-48ec-8192-13d1240eb3b7",
            "name": "folder 5",
            "description": null,
            "path": "folder 5",
            "section": "UseCase",
            "type": "UseCase",
            "children": [],
            "userStoryCount": 0,
            "useCaseCount": 0,
            "testCaseCount": 0,
            "lastModifiedAt": "2025-02-08T08:31:58.071946Z"
        },
        {
            "id": "c2abad28-4521-4d16-9520-0ae97fe665d3",
            "name": "folder6",
            "description": null,
            "path": "folder6",
            "section": "UseCase",
            "type": "UseCase",
            "children": [],
            "userStoryCount": 0,
            "useCaseCount": 0,
            "testCaseCount": 0,
            "lastModifiedAt": "2025-02-08T08:31:58.071946Z"
        }
    ];


    const handleChangeSelection = (e, itemData) => {
        console.log(itemData, "itemDatatop", e.target.value)

        if (itemData?.type === LocalEntity.folder) {
            console.log(itemData, "itemDatatop folder")
            if (e.target.checked) {

                let selectedList = [...selectedItemsList];
                // selectedList = selectedList.concat(addChildren(itemData, selectedList));
                setSelectedItemsList(selectedList);

                console.log("folder result list add", selectedList, selectedItemsList)
            } else {

                let selectedList = [...selectedItemsList];
                // selectedList = removeChildren(itemData, selectedList);
                setSelectedItemsList(selectedList);

                console.log("folder result list remove", selectedList, selectedItemsList)
            }
        } else {
            console.log(itemData, "itemDatatop items")
            if (e.target.checked) {
                let selectedList = [...selectedItemsList];

                let foundIndex = selectedList?.findIndex((data) => data?.customId === itemData?.customId && data?.folderPath === itemData?.folderPath);

                if (foundIndex === -1) {
                    selectedList.push(itemData);
                }

                setSelectedItemsList(selectedList);
                console.log("item result list add", selectedList, selectedItemsList)


            } else {
                let list = selectedItemsList;
                list = list?.filter((data) => !(data.customId === itemData.customId && data.folderPath === itemData.folderPath));
                setSelectedItemsList(list);

                console.log("item result list remove", list, selectedItemsList, itemData, e.target.value)
            }
        }
    }

    const handleClose = () => {
        onClose();
    }

    return (
        <Box className=" flex flex-col gap-0 w-full h-full overflow-hidden" borderRadius={theme.shape.borderRadius} bgcolor={theme.palette.background.paper}>
            <Box className="flex items-center justify-between gap-4 px-4 py-2 border-b">
                <IconButton onClick={handleClose}>
                    <ArrowBackOutlined />
                </IconButton>
                {/* <Typography fontSize={font.size.fs_5} color="textSecondary" className="flex-1  ">Create Graph</Typography> */}

                <TextField placeholder="Title" fullWidth />
                <Box className="flex items-center px-0 py-2 border-t">
                    <Button variant="contained" fullWidth color="secondary" sx={{ color: theme.palette.secondary.contrastText }}>Save</Button>
                </Box>

                {/* <IconButton>
                    <SaveOutlined />
                </IconButton> */}
            </Box>

            <Box className="flex-1 flex items-center gap-0 overflow-auto divide-x" >

                {/* folder list */}
                <Box className="flex flex-col gap-4 h-full w-[40%]">

                    <Box className="flex-1 flex flex-col px-4 py-2">
                        <AutoSizer>
                            {({ height, width }) => {
                                console.log(height, width, "heightwidth")
                                return (
                                    <Tree
                                        initialData={folderList}
                                        openByDefault={true}
                                        width={width}
                                        height={height}
                                        indent={24}
                                        rowHeight={48}
                                    // overscanCount={1}
                                    // paddingTop={30}
                                    // paddingBottom={10}
                                    // padding={25 /* sets both */}
                                    >
                                        {({ node, style, dragHandle }) => (
                                            <Node node={node} style={style} dragHandle={dragHandle} selectedItemsList={selectedItemsList} handleChangeSelection={handleChangeSelection} />
                                        )}
                                    </Tree>

                                )
                            }}
                        </AutoSizer>
                    </Box>
                </Box>

                {/* preview button */}
                <Box className="flex flex-col items-center justify-center px-2 py-2 h-full" bgcolor={theme.palette.background.custom}>
                    <Button variant="contained" color="secondary" sx={{ color: theme.palette.secondary.contrastText, }}>
                        Preview
                    </Button>
                </Box>


                {/* graph container */}
                <Box className="flex-1 flex flex-col px-4 py-2 gap-4 h-full">

                    <GraphComponent title={`Graph`} list={list} style={{ width: "100%", height: "100%" }} />

                </Box>

            </Box>
        </Box>
    )
}


function GraphPreview({ data, onClose }) {

    const handleClose = () => {
        onClose();
    }


    return (
        <Box className=" flex flex-col gap-0 w-full h-full">
            <Box className="flex items-center justify-between gap-2 px-4 py-2 border-b">
                <IconButton onClick={handleClose}>
                    <ArrowBackOutlined />
                </IconButton>
                <Typography fontSize={font.size.fs_5} color="textSecondary" className="flex-1  ">{data?.title}</Typography>

                <IconButton>
                    <MoreHorizOutlined />
                </IconButton>
            </Box>

            <Box className="flex-1 flex flex-col  gap-0 overflow-auto">
                <Box className="flex-1 flex flex-col gap-2 px-0 py-0 overflow-auto   ">
                    <GraphComponent title={data?.title} data={data?.data} style={{ width: "auto", height: "100%" }} />
                </Box>

                <Box className="flex-1 flex-col gap-2 px-4 py-2  h-full w-full ">
                    <CounterTableComponent data={data.tableList} />
                </Box>
            </Box>

        </Box>
    )
}


export function CounterTableComponent({ data, }) {
    const theme = useTheme();

    const TableComponents = {
        Scroller: forwardRef((props, ref) => <TableContainer component={Paper} style={{ overflowX: "auto", overflowY: "scroll" }} {...props} ref={ref} />),
        Table: (props) => <Table {...props} style={{ borderCollapse: 'separate' }} />,
        TableHead: TableHead,
        TableRow: (props) => <TableRow {...props} />,
        TableBody: forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
        TableCell: (props) => <TableCell {...props} sx={{ ...props?.sx, px: "1rem !important" }} />,
    }

    let columns = [
        {
            label: "Name",
            key: "name",
            sx: {
                width: "100%", maxWidth: "100%", background: theme.palette.header.main,
            }
        },
        {
            label: "Count",
            key: "count",
            sx: {
                minWidth: "120px", maxWidth: "100%", background: theme.palette.header.main,
            }
        }
    ]

    const dataList = [
        ...data
    ];

    console.log(dataList, "dataList");

    return (
        <Box className="flex flex-col gap-0 w-full h-full">
            <TableVirtuoso
                style={{ width: "100%", height: "100%", overflowX: 'auto', }}
                data={dataList}
                components={TableComponents}
                fixedHeaderContent={() => (
                    <TableHead>
                        {false &&
                            columns?.map((item, index, arr) => {
                                return (
                                    <TableCell key={index} align="left" padding={"none"} className="whitespace-nowrap" style={{ margin: "0 1rem !important", fontWeight: "bold", ...item?.sx, borderRight: arr?.length - 1 === index ? "none" : `1px solid ${grey[300]}` }}>
                                        <ValueComponent text={item?.label} className="whitespace-nowrap py-1 px-2" fontWeight="bold" />
                                    </TableCell>
                                )
                            })
                        }

                        <TableCell align="left" padding={"none"} className="" style={{ margin: "0 1rem !important", fontWeight: "bold", minWidth: "150px", width: "100%", maxWidth: "100%", background: theme.palette.header.main, borderRight: `1px solid ${grey[300]}` }}>
                            <LightTooltip title={`Location`}>
                                <Box className="flex  py-1 px-2 overflow-hidden ">
                                    <ValueComponent text={"Location"} className=" w-fit truncate " fontWeight="bold" />
                                </Box>
                            </LightTooltip>
                        </TableCell>

                        {
                            dataList[0]?.properties?.map((item, index, arr) => {
                                return (
                                    <TableCell align="left" padding={"none"} className="overflow-hidden" style={{ overflow: "hidden", margin: "0 1rem !important", fontWeight: "bold", minWidth: "100px", maxWidth: "100px", background: theme.palette.header.main, borderRight: arr?.length - 1 === index ? "none" : `1px solid ${grey[300]}` }}>
                                        <LightTooltip title={`${item?.name}`}>
                                            <Box className="flex py-1 px-2 overflow-hidden ">
                                                <ValueComponent text={item?.name} className=" truncate text-wrap " fontWeight="bold" />
                                            </Box>
                                        </LightTooltip>
                                    </TableCell>
                                )
                            })
                        }

                        {/* <TableCell align="left" padding={"none"} className="whitespace-nowrap" style={{ margin: "0 1rem !important", fontWeight: "bold", width: "100%", maxWidth: "100%", background: theme.palette.header.main, borderRight: `1px solid ${grey[300]}` }}>

                        <ValueComponent text={"Module Name"} className="whitespace-nowrap py-1 px-2" fontWeight="bold" />
                    </TableCell>

                    <TableCell align="left" padding={"none"} className="whitespace-nowrap" style={{ margin: "0 1rem !important", fontWeight: "bold", minWidth: "120px", maxWidth: "100%", background: theme.palette.header.main, }}>

                        <ValueComponent text={"Count"} className="whitespace-nowrap py-1 px-2" fontWeight="bold" />
                    </TableCell> */}
                    </TableHead>
                )}


                itemContent={(index, itemData) => (

                    <TableRow sx={{ "&:hover": { background: grey[100], }, display: "table-row" }}>

                        <TableCell padding="none" align="left" sx={{ minWidth: "100px", width: "100%", maxWidth: "100%", borderRight: `1px solid ${grey[300]}` }} >
                            <ValueComponent text={`${itemData?.["name"]}`} className=" px-2 py-1" />
                        </TableCell>

                        {
                            itemData?.properties?.map((item, index, arr) => {
                                return (
                                    <TableCell padding="none" align="left" sx={{ minWidth: "100px", maxWidth: "100px", borderRight: arr?.length - 1 === index ? "none" : `1px solid ${grey[300]}` }} >
                                        <LightTooltip title={item?.value} >
                                            <ValueComponent text={`${item?.value}`} className=" px-2 py-1" />
                                        </LightTooltip>
                                    </TableCell>
                                )
                            })
                        }

                        {/* <TableCell padding="none" align="left" sx={{ width: "100%", maxWidth: "100%", borderRight: `1px solid ${grey[300]}` }} >

                        <ValueComponent text={`${itemData?.name}`} className="line-clamp-1 px-2 py-1" />
                    </TableCell>

                    <TableCell padding="none" align="left" sx={{ minWidth: "120px", maxWidth: "100%", }} >
                        <LightTooltip title={<ValueComponent text={`${itemData?.count}`} />} placement="left">

                            <ValueComponent text={`${itemData?.count}`} className="line-clamp-1 px-2 py-1" />
                        </LightTooltip>
                    </TableCell> */}

                    </TableRow>

                )}
            />
        </Box>
    )
}

function GraphComponent({ title, data, props }) {
    const theme = useTheme();

    const [chartDataList, setChartDataList] = useState(null);

    const options = {
        ...CHART_OPTIONS,

        plugins: {
            ...CHART_OPTIONS.plugins,
            title: {
                ...CHART_OPTIONS.plugins.title,
                display: false,

            }
        },
    };


    const outputData = {
        labels: ["Folder1", "Folder2", "Folder3", "Folder4", "Folder5"],
        datasets: [
            {
                label: "HIGH",
                data: [20, 20, 20, 20, 20],
                backgroundColor: theme.palette.secondary.main,
            },
            {
                label: "MEDIUM",
                data: [30, 30, 30, 30, 30],
                backgroundColor: theme.palette.secondary.main,
            },
            {
                label: "LOW",
                data: [60, 60, 60, 60, 60],
                backgroundColor: theme.palette.secondary.main,
            },
        ],
    };


    function transformData1(inputList) {
        const labels = inputList?.map(item => item.name);
        const datasets = inputList[0].properties?.map(prop => ({
            label: prop.name,
            data: inputList?.map(item => item.properties?.find(p => p.name === prop.name).value),
            backgroundColor: theme.palette.secondary.main,
        }));

        return { labels, datasets };
    }

    let COLORS = [
        red[400],
        pink[400],
        purple[400],
        deepPurple[400],
        indigo[400],
        blue[400],
        lightBlue[400],
        cyan[400],
        teal[400],
        green[400],
        lightGreen[400],
        lime[400],
        yellow[400],
        amber[400],
        orange[400],
        deepOrange[400],
    ];

    function transformData5(inputList) {
        const labels = inputList?.map(item => item.name);
        const datasets = Array.from(new Set(inputList?.flatMap(item => item.properties?.map(prop => prop.name))))?.map((name, index) => ({
            label: name,
            data: inputList?.map(item => item.properties?.find(prop => prop.name === name)?.value),
            // backgroundColor: COLORS[index % COLORS.length]
            backgroundColor: CHART_COLORS[index][400],
        }));

        return { labels, datasets };
    }

    function transformData(labelList, datasetList, colorList) {
        const labels = labelList?.map(item => item);
        const datasets = datasetList?.map((dataSet, index) => ({
            label: dataSet?.label,
            data: dataSet?.data,
            backgroundColor: colorList ? colorList[index] : CHART_COLORS[index][400],
            borderColor: colorList ? colorList[index] : CHART_COLORS[index][700],
            borderWidth: 1,
        }));

        return { labels, datasets };
    }

    // console.log("datasets", transformData5(list))



    // useEffect(() => {
    //     if (list?.length > 0) {
    //         setChartDataList(transformData5(list));
    //     }
    // }, [list]);

    useEffect(() => {
        if (data) {
            setChartDataList(transformData(data?.labels, data?.datasets, data?.colorsList));
        }
    }, [data]);


    /*
    {
    "labels": [
        "Folder1",
        "Folder2",
        "Folder3",
        "Folder4",
        "Folder5"
    ],
    "datasets": [
        {
            "label": "HIGH",
            "data": [
                20,
                20,
                20,
                20,
                20
            ],
            "backgroundColor": "#1A73E8"
        },
        {
            "label": "MEDIUM",
            "data": [
                30,
                30,
                30,
                30,
                30
            ],
            "backgroundColor": "#1A73E8"
        },
        {
            "label": "LOW",
            "data": [
                60,
                60,
                60,
                60,
                60
            ],
            "backgroundColor": "#1A73E8"
        }
    ]
}
    */


    console.log(chartDataList, "chartDataList")

    return (
        <Box className="flex items-center justify-center px-4 py-4 w-full h-full ">
            {chartDataList && <Bar options={options} data={chartDataList} redraw width={props?.width ? props?.width : "auto"} height={props?.height ? props?.height : "100%"} />}
        </Box>
    )
}

class LocalEntity {
    static folder = "folder";
    static useCase = "useCase";
    static userStory = "userStory";
    static testCase = "testCase";
}

function Node({ node, style, dragHandle, selectedItemsList, handleChangeSelection }) {
    const { activeProject, isUpdateFolderStructure, setIsUpdateFolderStructure, currentFolderAnchorEl, setCurrentFolderAnchorEl } = useApplicationContext();
    const theme = useTheme();



    const handleFolderClick = (folder) => {
    }

    const handleIconClick = (folder) => {
        folder.toggle();
    }

    const handleRightClick = (event, folder) => {
        event.preventDefault();
    }

    const checkChecked = () => {
        let isChecked = false;
        let isInderminate = false;

        if (node.data.type === LocalEntity.folder) {
            isChecked = checkFolderItems(node?.data)?.isChecked;
            isInderminate = checkFolderItems(node?.data)?.isIndeterminated;
            // isChecked = node?.data?.children?.every((child) => selectedItemsList?.includes(child?.customId));
            // isInderminate = selectedItemsList?.some((item) => node?.data?.children?.some((child) => child?.customId === item)) && !isChecked

        } else {
            let foundItem = selectedItemsList?.find((data) => data?.customId === node?.data?.customId && data?.folderPath === node?.data?.folderPath);
            isChecked = Boolean(foundItem);
            isInderminate = false
        }

        return { isChecked, isInderminate }
    }


    function checkFolderItems(folder) {
        let totalItemsCount = 0;
        let checkedItemsCount = 0;
        let isIndeterminated = false;

        if (folder?.children?.length === 0) {
            return { isChecked: false, isIndeterminated: false, totalItemsCount: 0, checkedItemsCount: 0 };
        }

        folder?.children?.forEach((item) => {
            if (item?.type === LocalEntity.folder) {
                const {
                    totalItemsCount: childTotalCount,
                    checkedItemsCount: childCheckedCount
                } = checkFolderItems(item);
                totalItemsCount += childTotalCount;
                checkedItemsCount += childCheckedCount;
                if (childCheckedCount > 0 && childCheckedCount < childTotalCount) {
                    isIndeterminated = true;
                }
            } else {
                totalItemsCount++;
                const foundItem = selectedItemsList?.find((data) =>
                    data?.customId === item?.customId &&
                    data?.folderPath === item?.folderPath
                );
                if (foundItem) {
                    checkedItemsCount++;
                }
            }
        });

        const isChecked = totalItemsCount === checkedItemsCount;
        if (checkedItemsCount > 0 && checkedItemsCount < totalItemsCount) {
            isIndeterminated = true;
        }

        return {
            isChecked,
            isIndeterminated,
            totalItemsCount,
            checkedItemsCount
        };
    }

    function checkFolderItems1(folder) {
        let totalItemsCount = 0;
        let checkedItemsCount = 0;
        let isIndeterminated = false;

        folder?.children?.forEach((item) => {
            if (item?.type === LocalEntity.folder) {
                const { totalItemsCount: childTotalCount, checkedItemsCount: childCheckedCount } = checkFolderItems(item);
                totalItemsCount += childTotalCount;
                checkedItemsCount += childCheckedCount;
                if (childCheckedCount > 0 && childCheckedCount < childTotalCount) {
                    isIndeterminated = true;
                }
            } else {
                totalItemsCount++;
                const foundItem = selectedItemsList?.find((data) =>
                    data?.customId === item?.customId &&
                    data?.folderPath === item?.folderPath
                );
                if (foundItem) {
                    checkedItemsCount++;
                }
            }
        });

        const isChecked = totalItemsCount === checkedItemsCount;
        if (checkedItemsCount > 0 && checkedItemsCount < totalItemsCount) {
            isIndeterminated = true;
        }

        return { isChecked, isIndeterminated, totalItemsCount, checkedItemsCount };
    }

    function checkFolderItems2(folder) {
        let totalItemsCount = 0;
        let checkedItemsCount = 0;
        let isChecked = true;
        let isIndeterminated = checkedItemsCount > 0 && checkedItemsCount < totalItemsCount;

        folder?.children?.forEach((item) => {
            if (item?.type === LocalEntity.folder) {
                const { isChecked: childChecked, isIndeterminated: childIndeterminated } = checkFolderItems(item);
                if (!childChecked) {
                    isChecked = false;
                }
                if (childIndeterminated) {
                    isIndeterminated = true;
                }
            } else {
                const foundItem = selectedItemsList?.find((data) => data?.customId === item?.customId && data?.folderPath === item?.folderPath);
                totalItemsCount = totalItemsCount + 1;
                checkedItemsCount = checkedItemsCount + 1;
                if (!foundItem) {
                    isChecked = false;
                    checkedItemsCount = checkedItemsCount - 1;
                    // isIndeterminated = true;
                }
            }
        });

        return { isChecked, isIndeterminated };
    }



    console.log(node, "nodegraph");

    console.log(currentFolderAnchorEl, "folderAnchorEl");


    return (
        <Box
            className={`flex items-center gap-1 py-1 px-2 cursor-pointer`}
            borderRadius={theme.shape.borderRadius}
            // style={style}
            // ref={dragHandle}
            // onClick={() => { handleFolderClick(node) }}
            sx={{
                // color: (currentFolderData?.id === node?.id) && theme.palette.secondary.contrastText,
                // background: (currentFolderData?.id === node?.id) && "rgba(0, 0, 0, 0.05)" 
                pl: (node.level * 4)
                // pl : (node.level * 2)
            }}

        >

            <Box className="" onClick={() => handleIconClick(node)}>
                {!node.isLeaf &&
                    (node.isOpen ?
                        <KeyboardArrowDown /> : <KeyboardArrowRight />
                    )
                }
            </Box>


            <Box className="flex-1 flex items-center gap-1 " borderRadius={theme.shape.borderRadius} bgcolor={grey[100]} onClick={() => handleFolderClick(node)} sx={{ pl: 0 }} onContextMenu={(e) => handleRightClick(e, node)}>

                {
                    console.log(
                        (node.data.type === "use_case" || node.data.type === "user_story") && selectedItemsList?.some((item, index) => {
                            console.log(item, index, "item some checkbox")
                            return item === node?.data?.customId
                        }),
                        "checkbox selectedItemsList",
                        node?.data?.customId,
                        selectedItemsList
                    )
                }

                {/* {node.data.type === FolderType.project &&
                    <Checkbox
                        size="small"
                        checked={checkChecked()?.isChecked}
                        indeterminate={checkChecked()?.isInderminate}
                        onChange={(e) => handleChangeSelection(e, node?.data)}
                    />
                }

                {node.data.type === FolderType.module &&
                    <Checkbox
                        size="small"
                        checked={checkChecked()?.isChecked}
                        indeterminate={checkChecked()?.isInderminate}
                        onChange={(e) => handleChangeSelection(e, node?.data)}
                    />
                }

                {(node.data.type === "use_case" || node.data.type === "user_story") &&
                    <Checkbox
                        size="small"
                        checked={checkChecked()?.isChecked}
                        onChange={(e) => handleChangeSelection(e, node?.data)}
                    />
                } */}

                <Checkbox
                    size="small"
                    checked={checkChecked()?.isChecked}
                    indeterminate={checkChecked()?.isInderminate}
                    onChange={(e) => handleChangeSelection(e, node?.data)}
                />


                {node.data.type === LocalEntity.folder &&
                    <FolderOutlined sx={{ fontSize: font.size.fs_3 }} />
                }

                {(node.data.type === LocalEntity.useCase || node.data.type === LocalEntity.userStory) &&
                    <DescriptionOutlined sx={{ fontSize: font.size.fs_3 }} />
                }

                <LightTooltip
                    title={<Box className="flex-1 flex items-center gap-2 ">

                        <Typography fontSize={font.size.fs_5} className="">
                            {`${node.data.name} `}
                        </Typography>
                    </Box>}
                    arrow
                    placement="right"
                >
                    <Box className="flex-1 flex flex-col justify-between gap-0 overflow-hidden ml-2">

                        <Typography fontSize={font.size.fs_6} lineHeight={font.size.fs_5} className="line-clamp-1 ">
                            {`${node.data.name} `}
                        </Typography>
                    </Box>
                </LightTooltip>
            </Box>


        </Box>
    );
}